import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchRateCardSuccess, fetchRateCardError, updateRateCardSuccess, updateRateCardError } from '../actions/RateCard';
import { getDocs, updateDoc } from 'firebase/services/rateCard';
import {FETCH_RATE_CARD, UPDATE_RATE_CARD} from 'constants/ActionTypes';

function* fetchRateCardRequest() {
  try {
    const fetchedRateCardList = yield call(getDocs);
    yield put(fetchRateCardSuccess(fetchedRateCardList));
  } catch (error) {
    console.log(error);
    yield put(fetchRateCardError(error));
  }
}

function* updateRateCardRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updateRateCardSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateRateCardError(error));
  }
}

export function* fetchRateCard() {
  yield takeEvery(FETCH_RATE_CARD, fetchRateCardRequest);
}

export function* updateRateCard() {
  yield takeEvery(UPDATE_RATE_CARD, updateRateCardRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchRateCard), fork(updateRateCard)]);
}
